module.exports = __webpack_public_path__ + "src/assets/img/guest_pool.bc326cc6.jpg";